import { pxToRem } from '@fluentsms/agentnet-web-components';
import { Theme, Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import VerifiedUserIcon from 'ui-kit/icons/VerifiedUser';

type BasicChipProps = {
  status: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardWrap: {
      width: 'fit-content',
      height: 15,
      borderRadius: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: theme.spacing(0.25),
      padding: theme.spacing(0, 1),
    },
    passCardWrap: {
      backgroundColor: '#E8F5E9',
    },
    failCardWrap: {
      backgroundColor: '#F6E3E2',
    },
    warningCardWrap: {
      backgroundColor: '#FFF3E0',
    },
    text: {
      fontWeight: 400,
      fontSize: pxToRem(8),
    },
    passText: {
      color: theme.palette.success.dark,
    },
    failText: {
      color: theme.palette.error.dark,
    },
    warningText: {
      color: theme.palette.warning.dark,
    },
    icon: {
      width: 10,
      height: 10,
    },
    failIcon: {
      color: theme.palette.error.main,
    },
    warningIcon: {
      color: theme.palette.warning.main,
    },
  }),
);

const BasicChip: React.FC<BasicChipProps> = ({ status }) => {
  const classes = useStyles();
  const lowerStatus = status.toLowerCase();

  return (
    <>
      {lowerStatus.includes('pass') && (
        <div className={clsx(classes.cardWrap, classes.passCardWrap)}>
          <VerifiedUserIcon className={classes.icon} />
          <Typography className={clsx(classes.text, classes.passText)}>Passed</Typography>
        </div>
      )}
      {lowerStatus.includes('fail') && (
        <div className={clsx(classes.cardWrap, classes.failCardWrap)}>
          <ErrorIcon className={clsx(classes.icon, classes.failIcon)} />
          <Typography className={clsx(classes.text, classes.failText)}>Failed</Typography>
        </div>
      )}
      {lowerStatus.includes('warn') && (
        <div className={clsx(classes.cardWrap, classes.warningCardWrap)}>
          <ReportProblemIcon className={clsx(classes.icon, classes.warningIcon)} />
          <Typography className={clsx(classes.text, classes.warningText)}>Warning</Typography>
        </div>
      )}
    </>
  );
};

export default BasicChip;
